/** Posições da chave de acesso de NF-e/CT-e (CNPJ alfanumérico: letras nas posições do CNPJ). */
export const TAMANHO_CHAVE = 44;

/** Só letras e números, em maiúsculas, até 44 posições — o que se cola costuma vir com espaços. */
export function limparChave(texto: string): string {
  return texto
    .replace(/[^0-9a-z]/gi, '')
    .toUpperCase()
    .slice(0, TAMANHO_CHAVE);
}

/** "2926 1011 2223 …": blocos de 4, como no DANFE. */
export function formatarBlocosChave(texto: string): string {
  return (limparChave(texto).match(/.{1,4}/g) ?? []).join(' ');
}
